// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1084E8","backgroundColor":"#E5EAF2"};